import Markdown from '@wandb/weave/common/components/Markdown';
import React from 'react';

interface MarkdownPreviewProps {
  fileBody: string | undefined;
}

export function MarkdownPreview({fileBody}: MarkdownPreviewProps) {
  return (
    <div className="p-16 border-wb-border rounded-lg border">
      <Markdown content={fileBody || ''} />
    </div>
  );
}
